import DateRangeFilter from "../widgets/DateRangeFilter";
import AccountFilter from "../widgets/AccountFilter";
import SearchFilter from "../widgets/SearchFilter"
import { usePath } from "../../libs/path/PathProvider";

export default function HistoryToolbar(){
    const {hash} = usePath()
    return <div className="toolbar flex middle gap-8">
        <AccountFilter/>
        <SearchFilter/>
        <DateRangeFilter/>
    </div>
}